import ListPageView from "../../components/ListPageView"

export default function GeneralActivityLog() {
  const ID_TEMPLATE = "general_activity_log"
  const ID_BLOCKS = ["activity__activity_log", "activity"]

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Location",
      field: "activity__location_ids",
      block: "activity",
      type: "location",
    },
    {
      header: "Activity Name",
      field: "activity_name",
      block: "activity__activity_log",
      type: "string",
    },
    {
      header: "Activity Type",
      field: "activity_type",
      block: "activity__activity_log",
      type: "activity_type",
    },
    {
      header: "Staff",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
    {
      header: "Attendees/Distributed",
      field: "activity_attendance|activity_distributed",
      block: "activity__activity_log",
      type: "attendees",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]

  return (
    <div className="main-content">
      <ListPageView
        idTemplate={ID_TEMPLATE}
        idBlocks={ID_BLOCKS}
        columns={listViewCols}
      />
    </div>
  )
}
